export default __webpack_public_path__ + "static/media/illustration-2-02 1.8f0ba2a6.png";